import { render, staticRenderFns } from "./MasterForm.vue?vue&type=template&id=712945cc&scoped=true"
import script from "./MasterForm.vue?vue&type=script&lang=js"
export * from "./MasterForm.vue?vue&type=script&lang=js"
import style0 from "./MasterForm.vue?vue&type=style&index=0&id=712945cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712945cc",
  null
  
)

export default component.exports